'use strict;'

export const CLICK_TO_VERIFY = 'click_to_verify';
export const VERIFYING = 'verifying';
export const SUCCESS = 'success';
export const UNAVAILABLE = 'unavailable';
export const INCOMPLETE = 'incomplete';
export const ERROR = 'error';
export const TESTING = 'testing';

export const STRINGS = {
    'en': {
        [CLICK_TO_VERIFY]: 'Click to verify',
        [VERIFYING]: 'Verifying',
        [SUCCESS]: 'Verified',
        [UNAVAILABLE]: 'Not available',
        [INCOMPLETE]: 'incomplete',
        [ERROR]: 'error',
        [TESTING]: 'testing',
    },
    'de': {
        [CLICK_TO_VERIFY]: 'Zum Bestätigen klicken',
        [VERIFYING]: 'Wird überprüft',
        [SUCCESS]: 'Verifiziert',
        [UNAVAILABLE]: 'Nicht verfügbar',
        [INCOMPLETE]: 'unvollständig',
        [ERROR]: 'fehler',
        [TESTING]: 'testmodus',
    },
    'es': {
        [CLICK_TO_VERIFY]: 'Haz clic para verificar',
        [VERIFYING]: 'Verificando',
        [SUCCESS]: 'Verificado',
        [UNAVAILABLE]: 'No disponible',
        [INCOMPLETE]: 'incompleto',
        [ERROR]: 'error',
        [TESTING]: 'prueba',
    },
    'fr': {
        [CLICK_TO_VERIFY]: 'Cliquez pour vérifier',
        [VERIFYING]: 'Vérification en cours',
        [SUCCESS]: 'Vérifié',
        [UNAVAILABLE]: 'Non disponible',
        [INCOMPLETE]: 'incomplet',
        [ERROR]: 'erreur',
        [TESTING]: 'test',
    },
    'it': {
        [CLICK_TO_VERIFY]: 'Clicca per verificare',
        [VERIFYING]: 'Verifica in corso',
        [SUCCESS]: 'Verificato',
        [UNAVAILABLE]: 'Non disponibile',
        [INCOMPLETE]: 'incompleto',
        [ERROR]: 'errore',
        [TESTING]: 'test',
    },
    'nl': {
        [CLICK_TO_VERIFY]: 'Klik om te verifiëren',
        [VERIFYING]: 'Bezig met verifiëren',
        [SUCCESS]: 'Geverifieerd',
        [UNAVAILABLE]: 'Niet beschikbaar',
        [INCOMPLETE]: 'onvolledig',
        [ERROR]: 'fout',
        [TESTING]: 'testen',
    },
    'sv': {
        [CLICK_TO_VERIFY]: 'Klicka för att verifiera',
        [VERIFYING]: 'Verifierar',
        [SUCCESS]: 'Verifierad',
        [UNAVAILABLE]: 'Inte tillgänglig',
        [INCOMPLETE]: 'ofullständig',
        [ERROR]: 'fel',
        [TESTING]: 'test',
    },
    'no': {
        [CLICK_TO_VERIFY]: 'Klikk for å bekrefte',
        [VERIFYING]: 'Bekrefter',
        [SUCCESS]: 'Bekreftet',
        [UNAVAILABLE]: 'Ikke tilgjengelig',
        [INCOMPLETE]: 'ufullstendig',
        [ERROR]: 'feil',
        [TESTING]: 'test',
    },
    'pl': {
        [CLICK_TO_VERIFY]: 'Kliknij, aby zweryfikować',
        [VERIFYING]: 'Weryfikowanie',
        [SUCCESS]: 'Zweryfikowano',
        [UNAVAILABLE]: 'Niedostępne',
        [INCOMPLETE]: 'niekompletne',
        [ERROR]: 'błąd',
        [TESTING]: 'test',
    },
    'fi': {
        [CLICK_TO_VERIFY]: 'Napsauta vahvistaaksesi',
        [VERIFYING]: 'Vahvistetaan',
        [SUCCESS]: 'Vahvistettu',
        [UNAVAILABLE]: 'Ei saatavilla',
        [INCOMPLETE]: 'epätäydellinen',
        [ERROR]: 'virhe',
        [TESTING]: 'testi',
    },
    'et': {
        [CLICK_TO_VERIFY]: 'Klõpsa kinnitamiseks',
        [VERIFYING]: 'Kinnitamine',
        [SUCCESS]: 'Kinnitatud',
        [UNAVAILABLE]: 'Pole saadaval',
        [INCOMPLETE]: 'puudulik',
        [ERROR]: 'viga',
        [TESTING]: 'test',
    }
};
